import { FC, createContext, useContext, useState } from 'react';

import { CeAcademicOfferStatus } from '../types';

export interface AcademicOfferWizardContextState {
  ceAcademicOfferId: number | null;
  setCeAcademicOfferId: (id: number) => void;
  offerStatus: CeAcademicOfferStatus | null;
  setOfferStatus: (status: CeAcademicOfferStatus) => void;
}

const contextDefaultValues: AcademicOfferWizardContextState = {
  ceAcademicOfferId: null,
  setCeAcademicOfferId: () => {
    throw new Error(
      'You must implement an AcademicOfferWizardProvider setCeAcademicOfferId handler',
    );
  },
  offerStatus: null,
  setOfferStatus: () => {
    throw new Error(
      'You must implement an AcademicOfferWizardProvider setOfferStatus handler',
    );
  },
};

export const AcademicOfferWizardContext = createContext<AcademicOfferWizardContextState>(
  contextDefaultValues,
);

export function useAcademicOfferWizard() {
  return useContext(AcademicOfferWizardContext);
}

interface AcademicOfferWizardProviderProps {
  initialOfferId?: number | null;
}

export const AcademicOfferWizardProvider: FC<AcademicOfferWizardProviderProps> = ({
  children,
  initialOfferId = null,
}) => {
  const [ceAcademicOfferId, setCeAcademicOfferId] = useState<number | null>(
    initialOfferId,
  );
  const [offerStatus, setOfferStatus] = useState<CeAcademicOfferStatus | null>(
    null,
  );

  return (
    <AcademicOfferWizardContext.Provider
      value={{
        ceAcademicOfferId,
        setCeAcademicOfferId,
        offerStatus,
        setOfferStatus,
      }}
    >
      {children}
    </AcademicOfferWizardContext.Provider>
  );
};
